// Vendor Libs
import {cloneDeep} from 'lodash';

const initialState = {
    active: false,
    echostarId: null,
    error: null,
    fetched: false,
    fetching: false,
    onSuccessCallbacks: {},
    response: null,
    roviProgramId: null,
    servicesDataKey: null,
    sourceId: null,
    tmsId: null,
};
const getInitialState = () => cloneDeep(initialState);

const actions = {
    FLAGGED_METADATA_SET_ACTIVE: (
        state,
        {active, echostarId, onSuccessCallbacks, roviProgramId, servicesDataKey, sourceId, tmsId}
    ) => ({
        ...state,
        active,
        echostarId,
        onSuccessCallbacks,
        roviProgramId,
        servicesDataKey,
        sourceId,
        tmsId,
    }),

    FLAGGED_METADATA_SUBMIT_POST: (state) => ({
        ...state,
        fetched: false,
        fetching: true,
    }),

    FLAGGED_METADATA_POST_FULFILLED: (state, {response}) => ({
        ...state,
        error: null,
        fetched: true,
        fetching: false,
        response,
    }),

    FLAGGED_METADATA_POST_REJECTED: (state, {error}) => ({
        ...state,
        fetched: true,
        fetching: false,
        error,
    }),

    FLAGGED_METADATA_RESET: () => getInitialState(),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
